exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "body {\n  margin: 0; }\n\n.cao-content {\n  margin: 3rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /workspace/chess.arska.org/chess/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/workspace/chess.arska.org/chess/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/workspace/chess.arska.org/chess/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/workspace/chess.arska.org/chess/src/styles.sass
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.sass
// module chunks = styles